
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IDashboardToggleSwitchProps,
  IDashboardToggleSwitchMapperProps,
  IDashboardToggleSwitchControllerProps,
  IDashboardToggleSwitchStateValues,
} from '../../../components/DashboardToggleSwitch/DashboardToggleSwitch.props';

export default withCompController<
  IDashboardToggleSwitchMapperProps,
  IDashboardToggleSwitchControllerProps,
  IDashboardToggleSwitchProps,
  IDashboardToggleSwitchStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { editorType } = stateValues
  return {
    ...mapperProps,
    editorType,
    updateComponentPropsInViewer: props => {
      controllerUtils.updateProps(props);
    }
  }
});
